import { useDicomStore, DicomFile } from '@/store/dicom'

class WebSocketService {
  private socket: WebSocket | null = null;
  private userId: string;
  private token: string;

  constructor(userId: string, token: string) {
    this.userId = userId;
    this.token = token;
  }

  connect(onMessage: (message: string) => void) {
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const wsUrl = `${protocol}://${location.host}/websocket/ws/${this.userId}?token=${this.token}`;
    this.socket = new WebSocket(wsUrl);

    this.socket.onopen = () => {
      console.log("WebSocket connected");
    };

    this.socket.onmessage = (event) => {
      const response = JSON.parse(event.data);
      switch (response.status) {
        case "Pending":
          useDicomStore().insertDicomList(response);
          break;
        case "In Progress":
          useDicomStore().updateDicomList(response);
          break;
        case "Completed":
          useDicomStore().updateDicomList(response);
          break;
        case "Duplicate Found":
          useDicomStore().insertDuplicationFile(response);
          break;
        case "Shared Existing":
          useDicomStore().checkDicomList(response);
          break;
        case "Failed":
          useDicomStore().updateDicomList(response);
          break;
        default:
          break;
      }
      useDicomStore().checkDuplicationFileExist();
      onMessage(event.data);
    };

    this.socket.onclose = () => {
      console.log("WebSocket disconnected");
    };

    this.socket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };
  }

  sendMessage(message: string) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message);
    } else {
      console.error("WebSocket is not connected.");
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
    }
  }
}

export default WebSocketService;